import { Form, Select, Spin } from 'antd';
import { useListTags } from 'client/modules/tags/services/hooks/useListTags';

export const TagGroupSelect = ({
  idTagGroup,
  name,
  label,
  placeholder,
}: {
  idTagGroup: number;
  name: (string | number)[];
  label: string;
  placeholder: string;
}) => {
  const { data, isFetching } = useListTags({
    enabled: true,
    request: { id_tag_group: idTagGroup },
  });

  const tags =
    data?.tag_groups?.find((g) => g.id_tag_group === idTagGroup)?.tags ?? [];

  const options = tags.map((tag) => ({
    value: tag.id_tag,
    label: tag.paths?.[0] ?? tag.tag,
  }));

  return (
    <Form.Item name={name} label={label}>
      <Select
        mode="multiple"
        placeholder={placeholder}
        allowClear
        loading={isFetching}
        notFoundContent={isFetching ? <Spin size="small" /> : undefined}
        filterOption={(input, option) =>
          String(option?.label).toLowerCase().includes(input.toLowerCase())
        }
        options={options}
        labelInValue
        className="w-full"
      />
    </Form.Item>
  );
};
